import { createModel } from "@rematch/core";
import { DashboardFilterState, NbaDistributionState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: NbaDistributionState = {
  nbaTopTen: [],
  loading: true,
  pending: null,
};

export const nbaDistribution = createModel<RootModel>()({
  state: initialState as NbaDistributionState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: Partial<NbaDistributionState>,
      requestId: string
    ) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchNbaDistribution(
      dashboardFilter: DashboardFilterState,
      rootState
    ) {
      const requestId = multiRequest.getRequestId();
      dispatch.nbaDistribution.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.nbaDistribution.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const nbaDistributionResult = await api.fetchNbaDistribution(
          token,
          dashboardFilter
        );
        dispatch.nbaDistribution.fetchSuccess(nbaDistributionResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.nbaDistribution.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/nbaDistribution.ts